import {deserialize, inheritSerialization, serialize} from "cerialize";
import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class BulkSekolahRequest extends BaseEntity {

    @serialize
    @deserialize
    public sekolah: string = "";

    @serialize
    @deserialize
    public from_tingkat: string = "";

    @serialize
    @deserialize
    public from_kelas: string = "";

    @serialize
    @deserialize
    public to_tingkat: string = "";

    @serialize
    @deserialize
    public to_kelas: string = "";

    public file: any = null;

    public static OnSerialized(instance: BulkSekolahRequest, json: any): void {
        if (parseInt(json.id) === 0) {
            delete json.id;
        }
    }

}
